<template>
    <div>
        <page-title heading="Info Subskripsi" :breadcrumb="[
        {
          label: 'Dashboard',
          link: '/',
        },
          {
          label: 'Info Subskripsi',
          active: true
        }
      ]" />
        <div class="app-content--inner p-0 d-flex flex-column">
            <div class="container-fluid">
                <div class="row justify-content-center">
                    <div class="col-md-12" style="font-size:13px;">
                        <div class="card card-box mb-2">
                            <div class="card-body">
                                <div class="text-center mt-4">
                                    <h3>
                                        Untuk melakukan subskripsi<br>
                                        silakan hubungi nomor marketing izidok dengan klik tombol di bawah ini <br><br>
                                        <b-button
                                         variant="primary"
                                         href="https://api.whatsapp.com/send/?phone=628111137982&text=Hai+Izidok%2C+saya+ingin+berlangganan.+Mohon+info+terkait+harga+paket+izidok&type=phone_number&app_absent=0" target="_blank">Klik di sini</b-button>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faPhone
} from "@fortawesome/free-solid-svg-icons";
import { mapGetters } from "vuex";

library.add(
  faPhone,
);

export default {
    data() {
        return {}
    },
    computed: {
        ...mapGetters({
            getRolesName: "getRolesName"
        }),
    },
    mounted() {
        if(!this.getRolesName.includes('pic_cabang')){
            this.$router.push("/")
        }
    },
}
</script>
<style lang="scss">
</style>